export const formatName = (name: { firstName?: string | null; lastName?: string | null } | undefined) =>
  `${name?.firstName ?? ''} ${name?.lastName ?? ''}`;
